import { LauraDashboard } from "@/app/components/laura/LauraDashboard";

export default function LauraPage() {
    return <LauraDashboard />;
}
